import React from 'react'
import './about.css'
import { translate, Trans } from 'react-i18next'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import ButtonLeft from './ButtonLeft'
import { LogoSvg } from './SVGarr'

const About = () => {
  return(
    <ReactCSSTransitionGroup
    transitionName="imgTransition"
    transitionAppear={true}
    transitionAppearTimeout={500}
    transitionEnter={false}
    transitionLeave={false}>
      <div className="about">
        <ButtonLeft url='/'/>
        {LogoSvg}
        <Trans i18nKey='about'>
          <p>
            Оформлення інтер'єру рослинами від студії фітодизайну «VAZON» – це:<br/>
            - індивідуальний підхід;<br/>
            - втілення ваших побажань;<br/>
            - дизайнерські креативні ідеї;<br/>
            - розкішні рослини;<br/>
            - кашпо, що доповнюють дизайн приміщення;<br/>
            - зелені стелі та стіни;<br/>
            - підвісні квіти;<br/>
            - природній декор.
          </p>
        </Trans>
      </div>
    </ReactCSSTransitionGroup>
  )
}

export default translate('translations')(About)


// WEBPACK FOOTER //
// ./src/components/about.jsx